import { render } from "./modal.vue?vue&type=template&id=5c450cce&scoped=true&ts=true"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"

import "./modal.vue?vue&type=style&index=0&id=5c450cce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c450cce"]])

export default __exports__